"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = void 0;

var tslib_1 = require("tslib");

var ui_grid_1 = require("@hopin-team/ui-grid");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_props_to_styles_1 = require("@hopin-team/ui-helper-props-to-styles");

var styled_components_1 = tslib_1.__importStar(require("styled-components"));

var ColorPatterns;

(function (ColorPatterns) {
  ColorPatterns["success"] = "GREEN[\"600\"]";
  ColorPatterns["danger"] = "UTILITY.ERROR";
  ColorPatterns["warning"] = "UTILITY.WARN";
  ColorPatterns["primary"] = "UTILITY.ACTION";
})(ColorPatterns || (ColorPatterns = {}));

var InverseColorPatterns;

(function (InverseColorPatterns) {
  InverseColorPatterns["success"] = "GREEN[\"100\"]";
  InverseColorPatterns["danger"] = "RED[\"100\"]";
  InverseColorPatterns["warning"] = "YELLOW[\"100\"]";
  InverseColorPatterns["primary"] = "BLUE[\"100\"]";
})(InverseColorPatterns || (InverseColorPatterns = {}));

var makeColorPatternStyles = function makeColorPatternStyles(colorPattern, theme) {
  return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  background: ", ";\n"], ["\n  background: ", ";\n"])), (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.".concat(ColorPatterns[colorPattern]), theme));
};

var makeInverseColorPatternStyles = function makeInverseColorPatternStyles(colorPattern, theme) {
  return (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  background: ", ";\n"], ["\n  background: ", ";\n"])), (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.".concat(InverseColorPatterns[colorPattern]), theme));
};

exports.Root = (0, styled_components_1.default)(ui_grid_1.Grid)(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  align-items: center;\n  min-height: 2.5rem;\n  background: ", ";\n\n  ", ";\n  ", ";\n"], ["\n  align-items: center;\n  min-height: 2.5rem;\n  background: ", ";\n\n  ", ";\n  ", ";\n"])), function (_a) {
  var theme = _a.theme,
      isInverse = _a.isInverse;
  return isInverse ? (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.GREY.WHITE", theme) : (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.GREY.DARK", theme);
}, function (props) {
  return (0, ui_helper_props_to_styles_1.makeStyles)(props, 'colorPattern', makeColorPatternStyles);
}, function (props) {
  return props.isInverse && (0, ui_helper_props_to_styles_1.makeStyles)(props, 'colorPattern', makeInverseColorPatternStyles);
});
var templateObject_1, templateObject_2, templateObject_3;